<template>
  <div class="html-content" v-html="value">
  </div>
</template>
<script>
  export default {
    props: {
      value: String
    }
  }
</script>
<style scoped lang='scss'>
  .html-content {
    word-break: break-word;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// HtmlContent.vue?22c7fd76